import {
  OMS_TRACK_YOUR_TRUCK_PATH,
  OMS_ORDER_TRACKING_PATH,
} from '../../constants/paths';
import { GetTrackPackageRequest } from '../../models/order-details';
import { ITrackYourTruckRequest } from '../../models/order-details/track-shipment';
import { apiB2B } from '../axios-client';
import { getUserId } from '../../utils/user';

export const GetTrackShipmentAPI = (requestData: GetTrackPackageRequest) => {
  const trackShipmentPayload = `?providerCode=${requestData.providerCode}&trackingNumber=${requestData.trackingNumber}&orderNumber=${requestData.orderNumber}`;
  const userId = getUserId() ?? '';
  const TrackShipment = `${OMS_ORDER_TRACKING_PATH(
    userId,
  )}${trackShipmentPayload}`;

  return apiB2B.get(TrackShipment);
};

export const GetTrackYourtruckAPI = (requestData: ITrackYourTruckRequest) => {
  const userId = getUserId() ?? '';
  return apiB2B.post(OMS_TRACK_YOUR_TRUCK_PATH(userId), requestData);
};
